import React from "react";
import { Link } from "react-router-dom";

const Cta = () => {
  return (
    <div id="cta" className="bg-earth">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16 lg:py-24">
        <div className="flex flex-col justify-between items-center lg:flex-row">
          <div className="max-w-3xl text-center lg:text-left">
            <div className="mb-4 font-semibold text-4xl md:text-5xl text-white">
              Ready to dive in?
            </div>
            <div className="text-2xl md:text-3xl text-yellow">
              To find out more on how we can help your business, please get in
              touch today.
            </div>
          </div>
          <div className="mt-12 lg:mt-0">
            <Link
              to="/contact"
              className="bg-white rounded-md shadow-md py-4 px-8 whitespace-nowrap text-xl font-medium text-earth"
            >
              Let's talk
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cta;
